import styled from 'styled-components';
import { fontTitle, fontBody } from 'Styles/fonts';
import { convertColorToThemeHexCode } from 'Styles/colors.util';
import breakpoint from 'Styles/breakpoints';
import BaseButton from '../Button/Button';
import TextInputOriginal from '../TextInput/TextInput';
import { Error } from '../FormInput/FormInput.styled';
import Icon from '../Icons/Icon';
import OverlayModal from '../ContentSystem/components/OverlayModal/OverlayModal';
import { Container as ModalContainer } from '../ContentSystem/components/OverlayModal/OverlayModal.styled';

export const Modal = styled(OverlayModal)`
  ${ModalContainer} {
    background-color: var(--border);
    min-height: 364px;
  }
`;

export const Container = styled.div`
  margin: 24px auto;
  max-width: 328px;

  ${breakpoint('medium')} {
    max-width: unset;
  }
`;

export const ContentContainer = styled.div`
  text-align: center;
`;

export const Heading = styled.h1`
  margin: 0;
  color: var(--primary);
  ${fontTitle(40)};
`;

export const HeadingSmall = styled(Heading)`
  ${fontTitle(24)}
  color: ${({ $color }) =>
    $color === convertColorToThemeHexCode('green')
      ? $color
      : convertColorToThemeHexCode('black')};
  margin-bottom: 8px;
`;

export const HeadingSmaller = styled(Heading)`
  ${fontTitle(18)}
  color: var(--foreground);
  ${({ $withBottomMargin }) => $withBottomMargin && 'margin-bottom: 16px;'}
  text-align: center;
`;

export const SubHeading = styled.p`
  color: var(--foreground);
  margin: 8px 0 16px;
  ${fontBody(14)}
`;

export const BodyCopy = styled.p`
  color: var(--foreground);
  margin: 0 0 8px;
  ${fontBody(14)}
`;

export const BodyCopySuccess = styled(BodyCopy)`
  color: var(--foreground);
`;

export const Button = styled(BaseButton)`
  margin-top: 24px;
  width: 100%;
`;

export const ButtonTextWrap = styled.div`
  display: flex;
`;

export const ButtonLink = styled(BaseButton).attrs({
  variant: 'secondary',
  isGhost: true,
  size: 'regular'
})`
  margin-top: 4px;
  width: 100%;
`;

export const ButtonContainer = styled.div`
  width: 248px;
  margin: 0 auto;
`;

export const TextInput = styled(TextInputOriginal)`
  ${Error} {
    text-align: start;
    color: var(--destructive);
  }

  ${breakpoint('medium')} {
    margin: 0 auto;
    width: 272px;
  }
`;

export const Disclaimer = styled.p`
  ${fontBody(12)};
  color: var(--ring);
  margin-top: 16px;

  a {
    color: var(--ring);
  }

  ${breakpoint('medium')} {
    padding: 0 160px;
  }
`;

export const Logo = styled(Icon).attrs({ name: 'logo-type', size: 20 })`
  margin-bottom: 32px;
`;

export const OfferMessageContainer = styled.div`
  margin: auto;
  max-width: 496px;
  margin-bottom: 40px;
`;

export const SubHeadingEmailSuccess = styled.p`
  color: var(--foreground);
  margin: 4px 0 16px;
  ${fontBody(14)}
`;
